export default __webpack_public_path__ + "static/media/mitigation-exposed-framing-drying-3.09301d48.jpg";